module.exports = __webpack_public_path__ + "static/media/right_logo.cb4a852c.svg";